import { httpApi } from 'core/httpApi';

export const deleteMyArchiveStory = async (storyId: string): Promise<void> =>
    httpApi.v2.delete(`stories/${storyId}`);
